import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isActive: false,
  viewers: [],
  selectedView: null,
};

const insightsSlice = createSlice({
  name: 'viewerInsights',
  initialState,
  reducers: {
    toggle(state) {
      const isActive = state.isActive;

      state.isActive = !isActive;

      if (isActive) {
        state.selectedView = null;
      }
    },
    selectView(state, action) {
      state.selectedView = action.payload;
    },
    populate(state, action) {
      state.viewers = action.payload;
    },
  },
});

export const { populate, toggle, selectView } = insightsSlice.actions;
export default insightsSlice.reducer;
